import { render, staticRenderFns } from "./Arbitrator.vue?vue&type=template&id=0750c242&"
import script from "./Arbitrator.vue?vue&type=script&lang=js&"
export * from "./Arbitrator.vue?vue&type=script&lang=js&"
import style0 from "./Arbitrator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports